var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c("div", { staticClass: "form-group" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value,
              expression: "value"
            }
          ],
          staticClass: "form-control selectpicker",
          attrs: { id: "form-" + _vm.parent.specification },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.value = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.updateFilters
            ]
          }
        },
        [
          _vm.parent.placeholder
            ? _c("option", { domProps: { value: "" } }, [
                _vm._v(_vm._s(_vm.parent.placeholder))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.flattenedControlOptions, function(value) {
            return _c(
              "option",
              {
                key: value.Value,
                class: value.customClassName,
                domProps: { value: value.Value }
              },
              [_vm._v(_vm._s(value.Name))]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }